import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    getInstitutionsTypes,
    getInstitutionsDropdown,
    getInstitutionsList,
    getInstitutionsAges,
    toggleDrawerMobileFilterSearch,
    setInstitutionsSearchCriteria
} from '../../actions';
import { getSidebarContent } from "../../../Content/actions";
import { Button, FormControl, InputLabel, Select, MenuItem, Drawer } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import classnames from 'classnames';
import { withLocalize, Translate } from 'react-localize-redux';
import ReactHtmlParser from 'react-html-parser';
import IconFilter from "../../assets/img/icon-filter.svg";
import { Helmet } from "react-helmet";
import { stripHtml } from '../../../../utils/stripHtml';

class InstitutionsSearch extends Component {
    formRef = React.createRef();

    state = {
        userClick: false,
        searchFormSticky: false,
        searchFormStickyWidth: 0,
    };

    constructor(props) {
        super(props);
        this.props.addTranslation(require('../../translations/translations_institutions_list'));
        this.props.addTranslation(require('../../translations/translations_institutionssearchbar'));
    }

    componentDidMount() {
        this.handlePageScroll();
        window.addEventListener('scroll', this.handlePageScroll);
        window.addEventListener('resize', this.handlePageScrollResize);

        // Scroll infini
        window.addEventListener('scroll', this.handleInfiniteScroll);

        this.fetchContent();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.languages !== this.props.languages) this.fetchContent();

        const { search } = this.props;

        if (
            this.state.userClick &&
            (search.type !== prevProps.search.type || search.selectedInstitution !== prevProps.search.selectedInstitution || search.age !== prevProps.search.age)
        ) {
            this.props.getInstitutionsList(
                1,
                true,
                search.type,
                search.selectedInstitution,
                search.age
            );
            this.setState({ userClick: false });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handlePageScroll);
        window.removeEventListener('resize', this.handlePageScrollResize);
        // Retirer le scroll infini
        window.removeEventListener('scroll', this.handleInfiniteScroll);
    }

    fetchContent() {
        const { taxonomiesLoading, institutionsDropdownLoading, agesLoading, sidebarLoading } = this.props;
        if (!taxonomiesLoading) this.props.getInstitutionsTypes();
        if (!institutionsDropdownLoading) this.props.getInstitutionsDropdown();
        if (!agesLoading) this.props.getInstitutionsAges();
        if (!sidebarLoading) this.props.getSidebarContent('agep_institutions');
    }

    handleChange = e => {
        const { name, value } = e.target;
        const newCriteria = {
            ...this.props.search,
            [name]: value
        };
        this.props.setInstitutionsSearchCriteria(newCriteria);
        this.setState({ userClick: true });
    };

    toggleFilterDrawer = () => this.props.toggleDrawerMobileFilterSearch();

    handlePageScroll = () => {
        if (!this.formRef.current) return;
        const width = this.state.searchFormStickyWidth || this.formRef.current.offsetWidth;
        const currentScroll = window.scrollY;
        const offset = document.getElementById('form-container').offsetTop + document.getElementById('site-header').offsetTop - 30;
        const isSticky = currentScroll >= offset;
        this.setState({ searchFormSticky: isSticky, searchFormStickyWidth: width });
    };

    handlePageScrollResize = () => {
        if (!this.formRef.current) return;
        const width = document.getElementById('form-container').offsetWidth;
        this.setState({ searchFormStickyWidth: width });
    };

    loadMoreInstitutions = () => {
        const { currentPage } = this.props;
        this.props.getInstitutionsList(
            currentPage + 1,         // page suivante
            false,                   // newSearch = false pour concaténer
            this.props.search.type,
            this.props.search.selectedInstitution,
            this.props.search.age
        );
    };

    handleInfiniteScroll = () => {
        const { loading, hasMore } = this.props;

        if (loading || !hasMore) return; // ne rien faire si on charge ou pas de page suivante

        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.offsetHeight;

        // Si on arrive à 100px du bas de la page, on charge la page suivante
        if (scrollTop + windowHeight >= documentHeight - 100) {
            this.loadMoreInstitutions();
        }
    };

    render() {
        const { types, institutionsDropdown, search, drawerMobileFilterSearchOpen, sidebar, sidebarLoading, institutions, totalFuture, taxonomiesLoading, institutionsDropdownLoading, loading, ages, agesLoading } = this.props;

        const menuItemsTypes = types.map(t => (
            <MenuItem value={t.term_id} key={t.term_id}>{t.name}</MenuItem>
        ));

        const menuItemsDropdown = institutionsDropdown.map(inst => (
            <MenuItem value={inst.id} key={inst.id}>{stripHtml(inst.title)}</MenuItem>
        ));

        // Dropdown ages options
        const menuItemsAges = ages.map(ageItem => (
                <MenuItem value={ageItem.term_id} key={ageItem.term_id}>{ageItem.name}</MenuItem>
            ));

        const sectionTitle = (!sidebar || !sidebar.agep_institutions || sidebarLoading)
            ? <span className="placeholder-line" />
            : ReactHtmlParser(sidebar.agep_institutions.widgets.titre.data.content);

        return (
            <Fragment>
                {this.state.searchFormStickyWidth > 0 &&
                    <Helmet>
                        <style type="text/css">{`
                            section#institutions-search form { width: ${this.state.searchFormStickyWidth}px; }
                        `}</style>
                    </Helmet>
                }

                <section id="institutions-search">
                    <div className="row">
                        <div className="col col-6 col-lg-12">
                            <Button size="medium" className="btnBack" component={Link} to="/">
                                <KeyboardBackspaceIcon />
                                <Translate id="institutions_list.button_back" />
                            </Button>
                            <Button size="medium" className="btnBack" component={Link} to={this.props.translate('routes.events')}>
                                <Translate id="header_navigation.evenement" />
                            </Button>
                            <Button size="medium" className="btnBack" component={Link} to={this.props.translate('routes.page_details').replace(':slug', this.props.translate('header_navigation.collaboration_lien'))}>
                                <Translate id="header_navigation.collaboration" />
                            </Button>
                        </div>
                        <div className="col col-6 d-lg-none">
                            <div className="float-right">
                                <Button size="medium" variant="contained" color="primary" className="btn-filter m-auto d-flex d-lg-none justify-content-center" onClick={this.toggleFilterDrawer}>
                                    <object data={IconFilter} type="image/svg+xml" />
                                    <Translate id="institutions_list.button_filter" />
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="row row-title">
                        <div className="col col-12">
                            <h1>
                                {sectionTitle}
                                {(!loading && institutions.length > 0 && totalFuture !== '') && (
                                    <span className="count">({totalFuture} <Translate id="institutions_list.request_count" />)</span>
                                )}
                            </h1>
                        </div>
                    </div>

                    <div className="form-container d-none d-lg-block" id="form-container">
                        <form ref={this.formRef} className={classnames('d-none d-lg-block', { sticky: this.state.searchFormSticky })}>
                            <div className="row">
                                <div className="col col-4">
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="institution-type"><Translate id="institutions_search_bar.type_institution" /></InputLabel>
                                        <Select
                                            value={search.type || ''}
                                            onChange={this.handleChange}
                                            inputProps={{ name: 'type', id: 'institution-type' }}
                                        >
                                            <MenuItem value=""><em><Translate id="institutions_search_bar.item_all" /></em></MenuItem>
                                            {menuItemsTypes}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col col-4">
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="institution-dropdown"><Translate id="institutions_search_bar.select_institution" /></InputLabel>
                                        <Select
                                            value={search.selectedInstitution || ''}
                                            onChange={this.handleChange}
                                            inputProps={{ name: 'selectedInstitution', id: 'institution-dropdown' }}
                                        >
                                            <MenuItem value=""><em><Translate id="institutions_search_bar.item_all" /></em></MenuItem>
                                            {menuItemsDropdown}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col col-4">
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="institution-age">
                                            <Translate id="institutions_search_bar.age" />
                                        </InputLabel>
                                        <Select
                                            value={search.age || ''}
                                            onChange={this.handleChange}
                                            inputProps={{ name: 'age', id: 'institution-age' }}
                                        >
                                            <MenuItem value="">
                                                <em><Translate id="institutions_search_bar.item_all" /></em>
                                            </MenuItem>
                                            {menuItemsAges}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>

                <Drawer id="filter-drawer" anchor="right" open={drawerMobileFilterSearchOpen} onClose={this.toggleFilterDrawer} className="header-drawer" classes={{
                    paper: 'header-drawer-paper almost-full',
                }}>
                    <div className="wrapper wrapper-top">
                        <div className="inner">
                            <div className="drawer-title">
                                <span className="section"><Translate id="institutions_search_bar.trouver_institution" /></span>
                                <h2 className="title"><Translate id="institutions_list.button_filter" /></h2>
                                <Button size="large" className="btn-close-drawer" onClick={this.toggleFilterDrawer}>
                                    <CloseIcon className="m-icon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper wrapper-bottom">
                        <div className="inner">
                            <form autoComplete="off">
                                <div className="row row-search">
                                    <div className="col col-12 mb-20">
                                        <FormControl fullWidth>
                                            <InputLabel htmlFor="institution-type">Type</InputLabel>
                                            <Select
                                                value={search.type || ''}
                                                onChange={this.handleChange}
                                                inputProps={{ name: 'type', id: 'institution-type' }}
                                            >
                                                <MenuItem value=""><em>All</em></MenuItem>
                                                {menuItemsTypes}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col col-12 mb-20">
                                        <FormControl fullWidth>
                                            <InputLabel htmlFor="institution-dropdown">Institution</InputLabel>
                                            <Select
                                                value={search.selectedInstitution || ''}
                                                onChange={this.handleChange}
                                                inputProps={{ name: 'selectedInstitution', id: 'institution-dropdown' }}
                                            >
                                                <MenuItem value=""><em>All</em></MenuItem>
                                                {menuItemsDropdown}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col col-12 mb-20">
                                        <FormControl fullWidth>
                                            <InputLabel htmlFor="institution-age">Age</InputLabel>
                                            <Select
                                                value={search.age || ''}
                                                onChange={this.handleChange}
                                                inputProps={{ name: 'age', id: 'institution-age' }}
                                            >
                                                <MenuItem value=""><em>All</em></MenuItem>
                                                {menuItemsAges}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row mt-20">
                                    <div className="col col-12">
                                        <Button onClick={this.toggleFilterDrawer} variant="contained" color="primary">Afficher résultats</Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Drawer>
            </Fragment>
        );
    }
}

InstitutionsSearch.propTypes = {
    getInstitutionsTypes: PropTypes.func.isRequired,
    getInstitutionsDropdown: PropTypes.func.isRequired,
    getInstitutionsList: PropTypes.func.isRequired,
    getSidebarContent: PropTypes.func.isRequired,
    toggleDrawerMobileFilterSearch: PropTypes.func.isRequired,
    setInstitutionsSearchCriteria: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
    types: PropTypes.array.isRequired,
    institutionsDropdown: PropTypes.array.isRequired,
    drawerMobileFilterSearchOpen: PropTypes.bool.isRequired,
    sidebar: PropTypes.object,
    sidebarLoading: PropTypes.bool,
    institutions: PropTypes.array,
    totalFuture: PropTypes.string,
    taxonomiesLoading: PropTypes.bool,
    institutionsDropdownLoading: PropTypes.bool,
    loading: PropTypes.bool,
    languages: PropTypes.array,
};

const mapStateToProps = state => ({
    types: state.institutions.types,
    institutionsDropdown: state.institutions.institutionsDropdown,
    search: state.institutions.search,
    drawerMobileFilterSearchOpen: state.institutions.drawerMobileFilterSearchOpen,
    sidebar: state.content.sidebar,
    sidebarLoading: state.content.sidebarLoading,
    institutions: state.institutions.institutions,
    totalFuture: state.institutions.totalFuture,
    taxonomiesLoading: state.institutions.taxonomiesLoading,
    institutionsDropdownLoading: state.institutions.institutionsDropdownLoading,
    loading: state.institutions.institutionsLoading,
    languages: state.localize.languages,
    ages: state.institutions.ages,
    agesLoading: state.institutions.agesLoading,
});

export default connect(mapStateToProps, {
    getInstitutionsTypes,
    getInstitutionsDropdown,
    getInstitutionsList,
    getInstitutionsAges,
    getSidebarContent,
    toggleDrawerMobileFilterSearch,
    setInstitutionsSearchCriteria
})(withLocalize(InstitutionsSearch));



// WEBPACK FOOTER //
// ./src/features/Institutions/components/List/InstitutionsSearch.js